<template>
  <div
    class="b-tag"
    :class="[
      `_${type}`,
      wide ? 'px-2' : 'px-1.5',
      { 'font-semibold': semibold, 'text-gray-700': pale, 'py-1': deletable }
    ]">
    <b-svg-icon v-if="icon" :name="icon" />

    <span class="b-tag__text">{{ title }}</span>

    <Button
      v-if="deletable && id"
      icon="pi pi-times"
      severity="secondary"
      size="small"
      text
      rounded
      @click="$emit('delete', id)" />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    title: string | number;
    type?: 'success' | 'info' | 'danger' | 'warning' | 'gray' | 'white' | 'primary';
    active?: boolean;
    semibold?: boolean;
    wide?: boolean;
    pale?: boolean;
    icon?: string;
    deletable?: boolean;
    id?: string | number | undefined;
  }>(),
  {
    type: 'gray',
    active: false,
    semibold: false,
    wide: false,
    pale: false,
    icon: undefined,
    deletable: false,
    id: undefined
  }
);

defineEmits<{
  (e: 'delete', id: string | number): void;
}>();
</script>

<style lang="postcss">
.b-tag {
  @apply flex items-center gap-1 rounded-xl text-sm;

  &._success {
    @apply bg-success-100 text-success-700;
  }

  &._info {
    @apply bg-info-100 text-info-700;
  }

  &._danger {
    @apply bg-danger-100 text-danger-700;
  }

  &._warning {
    @apply bg-warning-100 text-warning-700;
  }

  &._gray {
    @apply bg-gray-100 text-gray-500;
  }

  &._white {
    @apply bg-white;
  }

  &._primary {
    @apply bg-primary-500 text-white;
  }

  .icons {
    @apply h-[14px] w-[14px];
  }
}
</style>
